import React from 'react';
import { useAuth } from '../../../context/auth-provider';
import { useDocumentTitle } from '../../hooks/use-document-title';
import { LogoMark } from '../../logo/logo-mark';
import { AppButton } from '../../button/app-button';
import { deskInPlan } from '../../../utils/products';
import {
  BrandRow,
  Card,
  Heading,
  Shell,
  Subheading,
  Wordmark,
} from '../../onboarding/onboarding.styled';

/**
 * NO HOME ANY MORE (resident-portal RP-9.9).
 *
 * A resident whose last home on Lobbero has gone — moved out while the app was
 * open, or signing in again afterwards — holds a valid session and nothing to
 * open with it. They used to get three panels of "Try again" (every /tenant
 * read answers 403), and then the SIGN-IN FORM while still signed in: the
 * guard sent them "home", and for somebody with no staff role and no portal
 * that resolved to '/'.
 *
 * This is the screen for that person: what happened, who to ask, and the one
 * thing they can do. Rendered by RequirePermission in place of the portal — it
 * is not a route of its own, so it cannot be bookmarked or reached by somebody
 * who has a home.
 */

export const NO_HOME_TITLE = 'You no longer have a home on Lobbero';
export const NO_HOME_TEXT = 'If this is a mistake, contact your building.';

// IS6, IS6-D4: the organisation dropped Lobbero Desk. Nobody is emailed; this is
// what a resident or a concierge sees the next time they open the app, and it
// neither blames them nor explains the owner's billing.
export const DESK_OFF_TITLE = 'Your building no longer uses this part of Lobbero';
export const DESK_OFF_TEXT = 'If this is a mistake, contact your building.';

export const PortalNoHome: React.FC = () => {
  const { logout, user } = useAuth();
  const deskOff = !deskInPlan(user);
  useDocumentTitle(deskOff ? 'Not available' : 'No home on Lobbero');

  return (
    <Shell>
      <Card>
        <BrandRow>
          <LogoMark size={40} aria-hidden="true" />
          <Wordmark>Lobbero</Wordmark>
        </BrandRow>
        <Heading>{deskOff ? DESK_OFF_TITLE : NO_HOME_TITLE}</Heading>
        <Subheading>{deskOff ? DESK_OFF_TEXT : NO_HOME_TEXT}</Subheading>
        <AppButton variant="secondary" onClick={() => logout()}>
          Sign out
        </AppButton>
      </Card>
    </Shell>
  );
};
